module.exports = ".align-buttons {\n  text-align: right; }\n\n.link {\n  text-decoration: underline;\n  color: #00215a; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-technician-maintenance/master-technician-maintenance.component.scss
// module id = ./src/app/master/master-technician-maintenance/master-technician-maintenance.component.scss
// module chunks = main